import { DASHBOARD_TODO_LIST_SHOWN_KEY, persistentStorage } from '#shared/lib/storage';

/**
 * Возвращает true, если это первый показ списка за всё время (и помечает показ в persistentStorage).
 * @kind helper
 * @returns `true` при первом показе, иначе `false`
 */
export function consumeDashboardTodoListFirstShow(): boolean {
    if (persistentStorage.getItem(DASHBOARD_TODO_LIST_SHOWN_KEY) === '1') {
        return false;
    }

    persistentStorage.setItem(DASHBOARD_TODO_LIST_SHOWN_KEY, '1');

    return true;
}
